var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviewNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #203662;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "run",
    transform: "translate(-4.001 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27341",
    "data-name": "Path 27341",
    className: "cls-1",
    d: "M667.859,6753.5a4.571,4.571,0,1,1,4.571,4.5A4.542,4.542,0,0,1,667.859,6753.5Zm3.524,2.249,3.809-2.249-3.809-2.25Zm-9.05,2.25a1.333,1.333,0,0,1-1.333-1.333v-13.334a1.333,1.333,0,0,1,1.333-1.333h13.333a1.333,1.333,0,0,1,1.333,1.333v4H662.334v9.333h4.8V6758Zm0-12h13.333v-2.668H662.334Z",
    transform: "translate(-657 -6738)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewNewIcon);
export default __webpack_public_path__ + "static/media/PreviewNewIcon.87fd0b17982d609196648c4bd6a4e53e.svg";
export { ForwardRef as ReactComponent };